"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getDataSet = exports.getSupportEventMap = exports.supportEventList = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Tencent is pleased to support the open source community by making SPA UI available.
 * Copyright (C) 2019, a Tencent company. All rights reserved.
 */
// 支持的事件
var supportEventList = ['onKeyPress', 'onKeyUp', 'onKeyDown', 'onMouseOver', 'onMouseOut', 'onMouseEnter', 'onMouseLeave', 'onClick']; // 获取操作事件map

exports.supportEventList = supportEventList;

var getSupportEventMap = function getSupportEventMap() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var result = {};
  supportEventList.map(function (item) {
    if (item && typeof data[item] !== 'undefined') {
      result[item] = data[item];
    }

    return item;
  });
  return result;
}; // 获取操作事件map


exports.getSupportEventMap = getSupportEventMap;

var getDataSet = function getDataSet() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var result = {};
  var key = '';

  if (_typeof(data) === 'object' && data) {
    for (key in data) {
      if (typeof key.indexOf !== 'undefined' && key.indexOf('data-') === 0) {
        result[key] = data[key];
      }
    }
  }

  return result;
};

exports.getDataSet = getDataSet;
var _default = {
  supportEventList: supportEventList,
  getSupportEventMap: getSupportEventMap,
  getDataSet: getDataSet
};
exports["default"] = _default;